module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/cake-283b50a98a961a476532999e1569c059.svg";